module.exports = require("swa-bootstrap-corporate-landing-home-page/search-environments");